
import React from 'react'
import './index.less'
console.log(React)
export default function Tips2(props) {
  return (<div className='tips2'>
    <span className='tips2_span'>啦到这里来</span>
  </div>)
}
